import classNames from "classnames";
import { useGlobalPrivacyControl } from "hooks";
import CheckIcon from "assets/check-solid.svg";
import { decodeToken } from "utils/functions/decodeToken";
import "./index.scss";

export const AppFooter = () => {
  const { supported, enabled, status } = useGlobalPrivacyControl();
  const currentYear = new Date().getFullYear();

  const allowTrackingValue = decodeToken()?.allowTracking;
  const allowTrackingClaim =
    allowTrackingValue === null ||
    allowTrackingValue === undefined ||
    allowTrackingValue === true ||
    allowTrackingValue === "true" ||
    allowTrackingValue === "True";

  // Show honored when either tracking is NOT allowed, OR GPC is enabled+supported.
  const honored = !allowTrackingClaim || (supported && enabled);

  return (
    <footer className="app-footer">
      <div className="app-footer__text">
        <p>©{currentYear} TPR Education IP Holdings, LLC. All Rights Reserved.</p>
        <p>The Princeton Review is not affiliated with Princeton University</p>
      </div>

      {honored && (
        <div className="app-footer__gpc" data-status={honored ? "honored" : status}>
          <div
            className={classNames("app-footer__gpc-icon", {
              "app-footer__gpc-icon--enabled": honored,
              "app-footer__gpc-icon--inactive": !honored,
            })}
            aria-hidden="true"
          >
            {honored && <img src={CheckIcon} alt="" />}
          </div>
          <span className="app-footer__gpc-text">Opt-Out Signal Honored</span>
        </div>
      )}
    </footer>
  );
};

